<template v-if="isPageValidated">
  <div class="all_job_color all_job_top top_overflow">
    <div class="row">
      <div class="container mobile_tab_container_hundered">
        <div
          class="full-page-container cnt_height common_scroll_content mobile_tab_full_left_right_padding new_layout_side"
        >
          <div class="full-page-sidebar my_sd_bar daily_paid_side_bar">
            <div class="full-page-sidebar-inner" data-simplebar>
              <div
                class="sidebar-container remove_pdng jb_side_bar internal_daily_paid_side_bar tab_padding_right_zero"
              >
                <!-- Keywords -->
                <div class="sidebar-widget">
                  <p>{{ $t('jobs.keywords') }}</p>
                  <div class="keywords-container">
                    <div class="keyword-input-container">
                      <input
                        type="text"
                        class="keyword-input"
                        :placeholder="$t('jobs.ph_gig_title')"
                        v-model="filter.keyword"
                        v-on:keyup.enter="getGigMissions"
                      />
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>

                <!-- Category -->
                <div class="sidebar-widget">
                  <p>{{ $t('jobs.category') }}</p>
                  <select
                    v-model="filter.category_id"
                    class="common_select_focus common_padding_left_right_20 height_unset desktop_margin_bottom_zero custom-select"
                    @change="getGigMissions"
                  >
                    <option value="">{{ $t('jobs.all') }}</option>
                    <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
                  </select>
                </div>

                <!-- Date Range -->
                <div class="sidebar-widget">
                  <p>{{ $t('jobs.date_range') }}</p>
                  <b-form-group class="desktop_margin_bottom_zero">
                    <date-range-picker
                      ref="picker"
                      :minDate="null"
                      :opens="'right'"
                      :locale-data="locale"
                      :auto-apply="true"
                      v-model="dateRange"
                      :ranges="false"
                      :append-to-body="true"
                      class="transactions_jb_calender timesheet_calender_new manage_job_date_claneder date_range_border_color_manage_job common_date_range_picker_new"
                    >
                      <div slot="input" slot-scope="picker">
                        {{ picker.startDate | datePicker1 }} - {{ picker.endDate | datePicker1 }}
                      </div>
                    </date-range-picker>
                  </b-form-group>
                </div>

<div class="sidebar-widget job_list_btn_search mobile_space_between">
                  <b-button
                    @click="clearFilters"
                    class="button ripple-effect search_all_red_btn filter_btn_widht_120 desktop_margin_left_zero"
                    style="background-color: red; margin-left: 20px"
                    >{{ $t('jobs.clear_filter') }}</b-button
                  >
                  <b-button
                    @click="getGigMissions"
                    class="button ripple-effect search_btn_all filter_btn_widht_120 desktop_margin_right_zero"
                    style="width: 120px"
                    >{{ $t('jobs.search') }}</b-button
                  >
                </div>
              </div>
            </div>
          </div>

          <div
            class="full-page-content-container job_list_height fit_height remove_white_bg"
            data-simplebar
          >
            <div
              class="full-page-content-inner job_list_btm full_box_grid_shows new_job_listss common_padding_30 add_white_bg"
            >
              <h1 class="page-title search_h1">{{ $t('jobs.gig_listing_heading') }}</h1>

              <div class="content margin-top-30" v-if="gigMissions.length > 0">
                <div
                  class="listings-container new_liting_containerz grid-layout"
                  v-for="gig in gigMissions"
                  :key="gig.id"
                  :current-page="currentPage"
                  :per-page="perPage"
                >
                  <!-- Gig Listing -->
                  <b-link
                    :to="{
                      name: 'allGigMissionDetail',
                      params: {
                        id: encrypt(gig.id),
                        gig_alias: gig.alias,
                      },
                    }"
                    class="new_job_listingz job-listing"
                    style="width: 100%"
                  >
                    <!-- Gig Listing Details -->
                    <div class="job-listing-details mobile_display_block new_job_listing_detailz">
                      <div
                        class="job_listing_card_inner mobile_display_block block_999 new_job_listing_card_innerz inner_flexz"
                      >
                        <div class="job-listing-description common_br_word_job_listing">
                          <h2 class="job-listing-company bold_heading_iinner suggested_title">
                            <b>{{ gig.title | capitalize }}</b>
                          </h2>
                          <p class="job_list_green_h4">
                            {{ $profile.currencySign }}{{ Number(gig.budget).toFixed(2) }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="job-listing-footer">
                      <ul class="daily_paid_uls">
                        <li v-if="gig.end_date">
                          <i class="icon-line-awesome-calendar-o"></i>{{ formatDate(gig.end_date) }}
                        </li>
                        <li v-if="gig.end_time">
                          <i class="icon-material-outline-access-time"></i>{{ formatTime(gig.end_time) }}
                        </li>
                        <li v-if="gig.category_name"><i class="icon-feather-users"></i>{{ gig.category_name }}</li>
                        <li v-if="gig.location">
                          <i class="icon-material-outline-location-on"></i>{{ gig.location | capitalize }}
                        </li>
                      </ul>
                    </div>
                  </b-link>
                  <!-- Gig Listing / End -->
                </div>
              </div>
              <div class="content text-center" v-else>
                <p><b>{{ $t('jobs.no_record_found') }}</b></p>
              </div>

              <div class="clearfix"></div>
              <nav class="pagination-box">
                <div class="page-row-box d-inline-block">
                  <b-form-group id="input-group-4">
                    <span class="d-inline-block">{{ $t('jobs.rows_per_page') }}</span>
                    <span class="d-inline-block"
                      ><b-form-select v-model="form.rowsPerPage" @change="getGigMissions" aria-label="Results per page">
                        <option>25</option>
                        <option>50</option>
                        <option>75</option>
                        <option>100</option>
                      </b-form-select></span
                    >
                  </b-form-group>
                </div>
                <div class="total-page-count d-inline-block">
                  <ul>
                    <li>
                      <span v-if="totalRows != 0">{{ from }} - {{ to }} of {{ totalRows }}</span>
                    </li>
                  </ul>
                </div>
                <ul class="pagination my_custom_pagination_prt">
                  <!-- Previous -->
                  <li
                    class="page-item next_prev_btn_custom_bg prev_mrgn_btn"
                    :class="{ disabled: currentPages === 1 }"
                  >
                    <router-link
                      v-if="currentPages > 1"
                      class="page-link"
                      :to="
                        currentPages - 1 === 1
                          ? { path: $route.path, query: { ...$route.query, page: undefined } }
                          : {
                              path: $route.path,
                              query: { ...$route.query, page: currentPages - 1 },
                            }
                      "
                    >
                      <!-- ‹ -->
                    </router-link>
                    <span v-else class="page-link">
                      <!-- ‹ -->
                    </span>
                  </li>

                  <!-- Numbered Pages -->
                  <li
                    v-for="page in paginationRange"
                    :key="page"
                    class="page-item"
                    :class="{ active: page === currentPages }"
                  >
                    <router-link
                      class="page-link number_page_class"
                      :to="
                        page === 1
                          ? { path: $route.path, query: { ...$route.query, page: undefined } }
                          : { path: $route.path, query: { ...$route.query, page } }
                      "
                    >
                      {{ page }}
                    </router-link>
                  </li>

                  <!-- Next -->
                  <li
                    class="page-item next_prev_btn_custom_bg next_mrgn_btn"
                    :class="{ disabled: currentPages === totalPages }"
                  >
                    <router-link
                      v-if="currentPages < totalPages"
                      class="page-link"
                      :to="{
                        path: $route.path,
                        query: { ...$route.query, page: currentPages + 1 },
                      }"
                    >
                      <!-- › -->
                    </router-link>
                    <span v-else class="page-link">
                      <!-- › -->
                    </span>
                  </li>
                </ul>
              </nav>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { POST_API } from "../../store/actions.type";
import { getMetaInfo } from '@/seo.config';
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  components: { DateRangePicker },

  metaInfo() {
    const base = getMetaInfo('/singapore-gig-missions');
    const canonical = 'https://elconnect.sg/singapore-gig-missions';
    const cur = parseInt(this.$route.query.page, 10) || 1;
    const total = Math.ceil(this.totalRows / this.perPage) || 1;
    return {
      ...base,
      link: [
        { rel: 'canonical', href: canonical, vmid: 'canonical' },
        ...(cur > 1 ? [{ rel: 'prev', href: cur === 2 ? canonical : `${canonical}?page=${cur - 1}` }] : []),
        ...(cur < total ? [{ rel: 'next', href: `${canonical}?page=${cur + 1}` }] : []),
      ],
    };
  },

  data() {
    return {
      isPageValidated: false,
      gigMissions: [],
      categories: [],
      totalRows: 0,
      from: "",
      to: "",
      currentPage: 1,
      perPage: 25,
      form: { rowsPerPage: 25 },
      filter: { keyword: "", category_id: "", date_from: "", date_to: "" },
      dateRange: { startDate: null, endDate: null },
      locale: {
        direction: "ltr",
        format: "DD-MMM-YYYY",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 0,
      },
      error_message: "",
      webUrl: process.env.VUE_APP_URL,
    };
  },

  filters: {
    capitalize(value) {
      if (!value) return "";
      return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
    },
    datePicker1(value) {
      if (!value) return "";
      return moment(value).format("DD MMM YYYY");
    },
  },

  methods: {
    encrypt(id) {
      return btoa(id);
    },
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD MMM YYYY");
    },
    formatTime(time) {
      if (!time) return "";
      if (/AM|PM/i.test(time)) return time;
      const parts = time.split(":");
      let hours = parseInt(parts[0]);
      const mins = parts[1];
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      return hours + ":" + mins + " " + ampm;
    },
    showAlert() {
      this.$swal({ position: "center", icon: "error", title: this.error_message, showConfirmButton: false, timer: 1500 });
    },
    getCategories() {
      return this.$store.dispatch(POST_API, { data: {}, api: "/api/gig-mission-categories" }).then(() => {
        if (!this.$store.getters.containsErrors) {
          this.categories = this.$store.getters.getResults.data || [];
        }
      });
    },
    getGigMissions() {
      window.scrollTo(0, 0);
      return this.$store.dispatch(POST_API, {
        data: {
          page: this.$route.query.page ? this.$route.query.page : '1',
          rowsPerPage: this.form.rowsPerPage,
          keyword: this.filter.keyword,
          category_id: this.filter.category_id || null,
          date_from: this.filter.date_from || null,
          date_to: this.filter.date_to || null,
        },
        api: "/api/gig-mission-list",
      }).then(() => {
        if (this.$store.getters.containsErrors) {
          this.error_message = this.$store.getters.getErrors;
          this.showAlert();
          return [];
        } else {
          const results = this.$store.getters.getResults;
          this.gigMissions = results.pageOfItems;
          this.totalRows = results.pager.totalItems;
          this.perPage = results.pager.pageSize;
          this.from = results.pager.from ? results.pager.from : 1;
          this.to = results.pager.to;
          return this.gigMissions;
        }
      });
    },
    clearFilters() {
      this.filter = { keyword: "", category_id: "", date_from: "", date_to: "" };
      this.dateRange = { startDate: null, endDate: null };
      this.currentPage = 1;
      this.getGigMissions();
    },
  },

  computed: {
    paginationRange() {
      const totalPages = this.totalPages;
      const current = this.currentPages;
      const chunkSize = 4;
      const currentChunkStart = Math.floor((current - 1) / chunkSize) * chunkSize + 1;
      const range = [];
      const end = Math.min(currentChunkStart + chunkSize - 1, totalPages);
      for (let i = currentChunkStart; i <= end; i++) range.push(i);
      return range;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
    currentPages() {
      const page = parseInt(this.$route.query.page, 10);
      return isNaN(page) || page < 1 ? 1 : page;
    },
  },

  watch: {
    '$route.query.page'(val) {
      this.currentPage = parseInt(val || '1');
      this.getGigMissions();
    },
    dateRange(val) {
      this.filter.date_from = val.startDate ? moment(val.startDate).format('YYYY-MM-DD') : '';
      this.filter.date_to   = val.endDate   ? moment(val.endDate).format('YYYY-MM-DD')   : '';
      this.currentPage = 1;
      this.getGigMissions();
    },
  },

  created() {
    this.getCategories();
    this.getGigMissions().then(() => {
      this.isPageValidated = true;
    });
  },
  mounted() {
    Promise.all([
      this.categories.length   ? Promise.resolve() : this.getCategories(),
      this.gigMissions.length  ? Promise.resolve() : this.getGigMissions(),
    ]).finally(() => {
      document.dispatchEvent(new Event('x-app-rendered'));
    });
  },
};
</script>

<style scoped>
::v-deep .vue-daterange-picker {
  display: block !important;
  width: 100% !important;
}
::v-deep .vue-daterange-picker .reportrange-text {
  width: 100% !important;
}
</style>
